import { Injectable, inject } from '@angular/core';
import { DialogService } from '@proget-shared/dialog';
import { Observable } from 'rxjs';

import { SetPasswordUrlComponent } from './component/set-password-url.component';

@Injectable({
  providedIn: 'root',
})
export class SetPasswordUrlService {
  private readonly dialog = inject(DialogService);

  public openDialog(url: string): Observable<void> {
    return this.dialog.custom<SetPasswordUrlComponent, void>(SetPasswordUrlComponent, {
      configuration: { url },
    });
  }
}
